import React, { useState } from "react"
import PropTypes from "prop-types"
import Link from "../../UI/Link/Link"
import { MenuDropdownElementPropTypes, MenuElementOrLinkPropTypes } from "./propTypes"

const MenuDropdownElement = props => {
    const { menuElement, style } = props
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    if (!menuElement?.link) return null
    return (
        <div
            className={style.menuElement}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
            onFocus={() => setIsDropdownOpen(true)}
            onBlur={e => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                    setIsDropdownOpen(false)
                }
            }}
        >
            <Link {...menuElement.link} className={`${style.menuLink}`} />
            {Array.isArray(menuElement?.dropdownLinksCollection?.items) &&
                menuElement?.dropdownLinksCollection?.items.length > 0 && (
                    <div className={style.dropdown} style={{ display: isDropdownOpen ? "flex" : "none" }}>
                        <div className={style.dropdownInner}>
                            {menuElement.dropdownLinksCollection.items.map((link, index) => (
                                <Link key={`${link.sys.id}_${index}`} {...link} className={style.dropdownLink} />
                            ))}
                        </div>
                    </div>
                )}
        </div>
    )
}

const MenuElements = props => {
    const { items, style } = props
    return items.map((menuElement, index) => {
        if (menuElement.__typename === "Link")
            return <Link key={`${menuElement.sys.id}_${index}`} {...menuElement} className={style.menuLink} />
        return <MenuDropdownElement key={`${menuElement.sys.id}_${index}`} menuElement={menuElement} style={style} />
    })
}

export default MenuElements

MenuDropdownElement.propTypes = MenuDropdownElementPropTypes

MenuElements.propTypes = {
    items: PropTypes.arrayOf(MenuElementOrLinkPropTypes),
    style: PropTypes.object,
}
